
<v-container
    class="step-container"
    v-if="site && current"
>
    <c-drop-message
        v-if     = "drag.notAllowed"
        :message ="drag.message"
    />

    <d-attach-confirm
        v-model = "attach.visible"
        :data   = "attach.data"
        @attach = "onAttach"
        @cancel = "onAttachCancel"
    />

    <drop @drop="onDrop" mode="cut" :accepts-type="onAcceptType">
        <v-row class="no-frame">
            <v-col class="step-first-column" style="border: none; padding: 0; min-height: 680px">
                <div
                    class="lm-border pa-3"
                    :style="index === 0 ? 'flex: 1' : ''" :class="mainBoxClass"
                >
                    <!-- Status -->
                    <v-row class="no-frame mt-0" >
                        <v-col class="no-frame">
                            <inc-status
                                v-model = "current.status"
                                :items  = "step.status"
                                :label  = "$t('invoice.status')"
                                @change = "onStatusChanged"
                            />
                        </v-col>
                    </v-row>
                    <!-- Status -->

                    <!-- Processing time -->
                    <inc-processing-interval
                        v-if    = "index === 0"
                        :data   = "data"
                        :status = "current.status"
                        :background = "collective ? 'field-group-background-blue' : ''"
                    />
                    <!-- Processing time -->

                    <!-- Order - main invoice -->
                    <v-row class="no-frame mt-0" >
                        <v-col class="no-frame mr-2">
                            <v-text-field
                                :label            = "$t('invoice.ordernumber')"
                                v-model           = "data.ordernumber"
                                :background-color = "fileEntryFieldBackground"
                                autocomplete      = "off"
                                autocorrect       = "off"
                                autocapitalize    = "off"
                                spellcheck        = "false"
                                @input            = "onOrdernumber"
                            />
                        </v-col>
                        <v-col class="no-frame ml-2">
                            <f-enum-select
                                v-if        = "hasTag('vandalism')"
                                v-model     = "data.vandalism"
                                :label      = "$t('invoice.forwardings')"
                                :readonly   = "readonly"
                                :background = "fileEntryFieldBackground"
                                module      = "inc"
                                type        = "forwardings"
                            />
                        </v-col>
                    </v-row>
                    <!-- Order - main invoice -->


                    <!-- Description -->
                    <v-row
                        v-if="hasTag('description')"
                        class="no-frame mt-5"
                    >
                        <v-textarea
                            no-resize
                            label          = "Beschreibung"
                            v-model        = "data.description"
                            :background-color = "fileEntryFieldBackground"
                            rows           = "8"
                            autocomplete   = "off"
                            autocorrect    = "off"
                            autocapitalize = "off"
                            spellcheck     = "false"
                        />
                    </v-row>
                    <!-- Description -->

                    <v-row
                        v-if  = "index === 0 && complainReasonAllowed"
                        class = "no-frame mt-4"
                        style="display: block;flex:1;"
                    >
                        <v-textarea
                            v-model        = "data.complaintreason"
                            :label         = "$t('invoice.complaintreason')"
                            :background-color = "fileEntryFieldBackground"
                            :rows          = "hasTag('assessmentselect') ? 3 : 8"
                            autocomplete   = "off"
                            autocorrect    = "off"
                            autocapitalize = "off"
                            spellcheck     = "false"
                            class="pt-0"
                            hide-details
                            no-resize
                        />
                    </v-row >
                    <v-row  class = "no-frame mt-4" v-if  = "index === 0">
                        <inc-manufacturer
                            v-model     = "data.manufacturer"
                            :rules      = "[requiredOnTerminationRule]"
                            :background = "fileEntryFieldBackground"
                            @changed    = "onManufacturer"
                        />
                    </v-row>
                </div>

                <!-- Abstract of issue step data -->
                <v-row
                    class="no-frame mt-3 mr-2"
                    v-if="hasTag('issue')"
                    style="flex:1;"
                >
                    <v-col class="no-frame">
                        <inc-issue-abstract
                            :incident   = "incident"
                            :data       = "previous"
                            :current    = "previousCurrent"
                            :unit       = "unit"
                            :collective = "collective"
                            style="height: 512px"
                        />
                    </v-col>
                </v-row>
                <!-- Abstract of issue step data -->

                <!-- Abstract of bid data -->
                <v-row
                    class="no-frame mt-3 mr-2"
                    v-if="isRepair && index !== 0"
                >
                    <v-col class="no-frame">
                        <v-col class="no-frame">
                            <inc-bid-abstract
                                :incident   = "incident"
                                :data       = "data"
                                :unit       = "unit"
                                :form       = "form"
                                :collective = "collective"
                                style       ="height: 512px"
                            />
                        </v-col>
                    </v-col>
                </v-row>
                <!-- Abstract of bid data -->

                <!-- Abstract of assessment data -->
                <v-row
                    class="no-frame mr-2 mt-2"
                    v-if="hasTag('assessment')"
                >
                    <v-col class="no-frame">
                        <inc-assessment-abstract
                            :assessment = "previousCurrent"
                            :data       = "data"
                        />
                    </v-col>
                </v-row>
                <!-- Abstract of assessment data -->

                <!-- assessment selection -->
                <v-row
                    class="no-frame mr-2"
                    v-if="hasTag('assessmentselect')"
                >
                    <v-col class="no-frame">
                        <v-hover>
                            <template v-slot:default="{ hover }">
                                <inc-assessment-selection
                                    :class    = "`elevation-${ hover ? 12 : 0}`"
                                    :invoice  = "current"
                                    :height   = "current.status.id === 31 ? 344 : 424"
                                    @selected = "onAssessment"
                                />
                                </template>
                        </v-hover>
                    </v-col>
                </v-row>
                <!-- assessment selection -->
            </v-col>

            <v-col class="step-middle-column" style="border: none; padding: 0; overflow-y: auto; width: calc(100% + 8px)">
                <!-- Abstract of maintenance contract data -->
                <c-contract-mnt-abstract
                    v-if       = "incident.typeId === type.maintenance"
                    class      = "lm-border pa-3 mt-0 mb-3"
                    :show-unit = "this.data.collection.length > 1"
                    style      = "height: 200px;"
                />
                <!-- Abstract of maintenance contract data -->

                <!-- Abstract of emergency contract data -->
                <c-contract-esc-abstract
                    v-if        = "incident.typeId === type.emergency || incident.typeId === type.guardcost"
                    :collective = "collective"
                    class       = "lm-border pa-3 mb-3"
                />
                <!-- Abstract of emergency contract data -->

                <p-invoice-sum
                    v-if         = "collective && this.data.collection.length > 1"
                    :invoice     = "data"
                    :status      = "current.status"
                    :show-costs  = "index !== 0 && incident.typeId !== 1 && !bid"
                    :calculation = "collectiveCalculation"
                    :collective  = "collective"
                    :validate    = "incident.typeId !== type.maintenance && incident.typeId !== type.emergency && incident.typeId !== type.assessmentcost && incident.typeId !== type.assessmentinvoice"
                    @stampmail   = "onSendStampMail"
                    @stamped     = "onStamped"
                    class        = "mb-3"
                    ref          = "invoicesum"
                />

                <p-inc-invoice-data
                    v-if         = "calculation && hasTag('assessmentselect')"
                    :show-costs  = "index !== 0 && incident.typeId !== 1 && !bid"
                    :form        = "form"
                    :data        = "current"
                    :bid         = "bid"
                    :unit        = "unit"
                    :collective  = "collective"
                    :calculation = "unitCalculation"
                    :validate    = "incident.typeId !== type.emergency && incident.typeId !== type.assessmentcost"
                    @stampmail   = "onSendStampMail"
                    @stamped     = "onStamped"
                    @reset       = "onReset"
                    class        = "mt-0"
                    :style="index === 0 || !complainReasonAllowed ? 'flex: 1' : ''"
                >
                    <template v-slot:required>
                        <div v-if="hasTag('assessmentselect')" >
                            <f-read-only-field
                                class="w-50 mr-2"
                                color="pt-0-5 pl-1 ro-background"
                                label="Rechnungsbetrag laut Vertrag"
                                :align-right="true"
                                dense
                                :value = "requiredPrice()"
                            />
                        </div>
                    </template>
                </p-inc-invoice-data>

                <p-inc-invoice-data
                    v-if         = "calculation && !hasTag('assessmentselect')"
                    :show-costs  = "index !== 0 && incident.typeId !== 1 && !bid"
                    :form        = "form"
                    :data        = "current"
                    :bid         = "bid"
                    :unit        = "unit"
                    :collective  = "collective && this.data.collection.length > 1"
                    :calculation = "unitCalculation"
                    :validate    = "incident.typeId !== type.emergency && incident.typeId !== type.assessmentcost"
                    @stampmail   = "onSendStampMail"
                    @stamped     = "onStamped"
                    @reset       = "onReset"
                    class        = "mt-0"
                    :style="index === 0 || !complainReasonAllowed ? 'flex: 1' : ''"
                />

                <v-row
                    v-if  = "index > 0 && complainReasonAllowed"
                    class = "no-frame lm-border pa-3 mt-4"
                    style="display: block;flex:1;"
                >
                    <f-title :title="$t('invoice.complaintreason')" />

                    <v-textarea
                        v-model        = "data.complaintreason"
                        rows           = "5"
                        autocomplete   = "off"
                        autocorrect    = "off"
                        autocapitalize = "off"
                        spellcheck     = "false"
                        class="pt-0"
                        hide-details
                        no-resize
                    />
                </v-row>
            </v-col>

            <v-col class="step-middle-column" style="max-width: calc(25% - 20px); border: none; padding: 0;">
                <div
                    class = "lm-border pa-3 mb-3"
                    v-if  = "isGwl"
                >
                    <f-title :title="$t('inc.edit.invoice.warranty')" class="mt-1"/>
                    <inc-warranty-edit
                        :site ="previousCurrent"
                    />
                </div>

                <p-inc-invoice-recipients
                    :usage      = "usage"
                    :separated  = "separated"
                    :recipients = "recipients"
                    :data       = "data"
                    :collective = "collective"
                    style       = "flex:1; overflow-y: scroll;"
                />
            </v-col>

            <v-col class="step-last-column">
                <crm-journal
                    :incident = "incident"
                    @front    ="onJournalFront"
                    style     = "margin-top: -10px"
                />
            </v-col>
        </v-row>
    </drop>
</v-container>
